import React, { FC, useContext } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDoubleTap } from 'use-double-tap';

import CloseIcon from '@material-ui/icons/Close';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';

import { useStyle } from 'src/contexts/StyleContext';
import { actions, CatalogContext } from 'src/contexts/Catalog';

import Styled from './CatalogZoomStyled';
import { Container } from 'src/styles';

import ButtonWithIcon from 'src/components/atoms/ButtonWithIcon';

import content from 'src/common/content';

import { sendCatalogEvent } from 'src/services/googleAnalytics/helpers/catalog';

const CatalogZoom: FC = () => {
  const [state, dispatch] = useContext(CatalogContext);

  const { style } = useStyle();

  const zoomOut = () => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    dispatch(actions.zoomOut());
  };

  const handleCloseButtonClick = () => {
    sendCatalogEvent.closeButtonClickZoomOut();
    zoomOut();
  };

  const handleZoomOutButtonClick = () => {
    sendCatalogEvent.buttonClickZoomOut();
    zoomOut();
  };

  const handleDesktopZoomOutPageClick = () => {
    if (!state.isDesktop) {
      return;
    }
    sendCatalogEvent.pageClickZoomOut();
    zoomOut();
  };

  const handleZoomOutDoubleTap = () => {
    sendCatalogEvent.doubleTapZoomOut();
    zoomOut();
  };

  const bindTap = useDoubleTap(handleZoomOutDoubleTap);

  const handleZoomOutEscKeyDown = () => {
    sendCatalogEvent.keyDownEscZoomOut();
    zoomOut();
  };

  useHotkeys('Escape', handleZoomOutEscKeyDown);

  document.getElementsByTagName('body')[0].style.overflow = 'hidden';

  const hasCurrentPagesData = !!state.exhibition.currentPagesData.length;

  return (
    <Styled.Wrapper>
      <Styled.WrapperImage
        contrast={style.contrast}
        onClick={handleDesktopZoomOutPageClick}
        isDesktop={state.isDesktop}
      >
        {hasCurrentPagesData && (
          <>
            <img
              src={state.exhibition.currentPagesData[0].image}
              {...bindTap}
              data-testid="zoom-image1"
            />
            {state.exhibition?.currentPagesData[1] && (
              <img
                src={state.exhibition.currentPagesData[1].image}
                {...bindTap}
                data-testid="zoom-image2"
              />
            )}
          </>
        )}
      </Styled.WrapperImage>
      <Styled.Navigation>
        <Container>
          <ButtonWithIcon
            icon={<ZoomOutIcon />}
            aria-label={`Diminuir zoom do ${content.platform}`}
            onClick={handleZoomOutButtonClick}
            data-testid="close-zoom-button"
          >
            Diminuir zoom
          </ButtonWithIcon>
        </Container>
      </Styled.Navigation>

      <Styled.Close data-testid="close-button" onClick={handleCloseButtonClick}>
        <CloseIcon />
      </Styled.Close>
    </Styled.Wrapper>
  );
};

export default CatalogZoom;
